/*
 * SPDX-FileCopyrightText: 2025 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import {
  CmsVideoComponent,
  FeaturesConfigModule,
  I18nModule,
  ImageGroup,
  Product,
} from '@spartacus/core';
import {
  ProductImageZoomComponentsModule,
  ProductImageZoomViewComponent,
} from '@spartacus/product/image-zoom/components';
import { IconModule, MediaModule, MediaService } from '@spartacus/storefront';
import { CustomVideoComponent } from '../../../video/video.component';
import { CommonModule } from '@angular/common';
import { ProductImageZoomModule } from '@spartacus/product/image-zoom';
import { CustomProductImageZoomThumbnailsComponent } from '../product-image-zoom-thumbnails/product-image-zoom-thumbnails.component';
import { ThumbnailsGroup } from '@spartacus/product/image-zoom/root';
import { map, Observable, of, shareReplay } from 'rxjs';

@Component({
  selector: 'cx-product-image-zoom-view',
  templateUrl: './product-image-zoom-view.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MediaModule,
    IconModule,
    CustomVideoComponent,
    I18nModule,
    FeaturesConfigModule,
    CommonModule,
    CustomProductImageZoomThumbnailsComponent,
  ],
})
export class CustomProductImageZoomViewComponent extends ProductImageZoomViewComponent {
  mediaService = inject(MediaService);

  isVideo(item: any) {
    return this.mediaService.getMedia(item)?.src.includes('.mp4');
  }

  convertToVideoSource(item: any): CmsVideoComponent {
    const sourceSet = this.mediaService.getMedia(item);
    return {
      video: { url: sourceSet?.src, altText: sourceSet?.alt },
      thumbnail: { url: item.thumbnail },
    };
  }
}
